function checkout() {
    const checkoutBtn = document.querySelector('button[name="checkout"], #checkout, .checkout-btn, .proceed-to-checkout');
    console.log(checkoutBtn)
    if (checkoutBtn) {
        checkoutBtn.addEventListener("click", (e) => {
            if (checkoutBtn.disabled) {
                e.preventDefault();
                return false;
            }

            // Khóa nút lại
            checkoutBtn.disabled = true;
            checkoutBtn.style.opacity = "0.6";
            checkoutBtn.style.cursor = "not-allowed";
            checkoutBtn.classList.add('bss-disable')

            // Nếu cần submit form hoặc chuyển trang
            setTimeout(() => {
                checkoutBtn.disabled = false;
                checkoutBtn.style.opacity = "1";
                checkoutBtn.style.cursor = "pointer";
                checkoutBtn.style.pointerEvents = "auto"; // chặn mọi click
                checkoutBtn.classList.remove('bss-disable')
            }, 5000); // sau 5s mới cho bấm lại
        });
    }
}


document.addEventListener("DOMContentLoaded", () => {
    const monsterActive = !!document.querySelector('script[src*="/cart_renderer"]');

    if (monsterActive) {
        // Remove data-open-cart so mini-cart JS won't hijack the cart icon click
        document.querySelectorAll('[data-open-cart]').forEach(el => {
            el.removeAttribute('data-open-cart');
        });

        // Hide the mini-cart drawer and overlay
        const miniCartEl = document.querySelector('[data-mini-cart]');
        if (miniCartEl) miniCartEl.remove();

        const overlay = document.querySelector('.overlay--dark');
        if (overlay) overlay.remove();

        // Ensure cart links go to /cart
        document.querySelectorAll('.cart-link').forEach(link => {
            link.setAttribute('href', '/cart');
        });

        return; // Skip the rest of the DOMContentLoaded logic
    }
    let quickAddDrawer = document.querySelector('.mini-cart ');
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    console.log('test');
                   
                    checkout()
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }

    
});

